export const SceneEndTransition = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform sampler2D uTextureOne;
uniform float progress;
void main(void) {
  vec2 uv= vTextureCoord;
  vec4 color = texture2D(uSampler,uv);
  vec4 color2 = 1.0-texture2D(uTextureOne,uv);
  vec3 diff = color2.rgb - (1.0/color2.rgb)*(progress);
  vec3 fin;
  if(color.r < diff.r && color.g < diff.g && color.b < diff.b){
     fin = color.rgb;
  }
  else{
     fin = mix(color.rgb,diff,progress);
  }
  gl_FragColor =vec4(fin, 1.0);
}
`;